module.exports = __webpack_public_path__ + "img/31a)Kempinski Hotel Heiligendamm.jpg";